/* ShadeMotorsDirect enhanced content: add-to-cart buttons (data-smd-add="id[,id...]") */
(function () {
  if (window.smdEcReady) return;
  window.smdEcReady = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.smd-ec [data-smd-add]');
    if (!btn || btn.disabled) return;
    var ids = btn.getAttribute('data-smd-add').split(',');
    var items = ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; });
    var label = btn.textContent;
    btn.disabled = true;
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.d.description || 'Could not add to cart');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
          document.querySelectorAll('.cart-count, .cart-count-bubble span, [data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
        });
        if (items.length > 1) {
          var a = document.createElement('a');
          a.href = root + 'cart';
          a.className = btn.className + ' is-added';
          a.textContent = 'Added. View cart';
          btn.replaceWith(a);
          return;
        }
        btn.classList.add('is-added');
        btn.textContent = 'Added';
        btn.disabled = false;
        setTimeout(function () { btn.textContent = label; btn.classList.remove('is-added'); }, 2500);
      })
      .catch(function (err) { btn.disabled = false; btn.textContent = 'Try again'; console.error(err); });
  });
})();